import React from 'react';
import IgnoreUserList from '../../../components/ignore-user/IgnoreUserList';
import Title from "../../../components/Title";

class SettingsBlocked extends React.Component {

    render() {

        return (
            <div className="settings-wrapper">
                <div className="block">
                    <Title className={"settings-title"} heading={"heading-2"} display={"display-2"}>Préférence de
                        blocage</Title>
                    <IgnoreUserList/>
                </div>
            </div>
        )
    }
}

export default SettingsBlocked;
